import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LatLngExpression } from 'leaflet';
import { Observable } from 'rxjs';
import { Route } from 'src/app/shared/models/route';
import { ConstantsService } from '../../constant/constants.service';
import { GenericCrudService } from '../../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class RouteService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	/**
	 *
	 * @param routeId
	 * @returns
	 */
	getRouteById(routeId: number): Observable<Route> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.routeUrl}/${routeId}`,
			'getRouteById'
		);
	}

	/**
	 *
	 * @param year
	 * @param month
	 * @param day
	 * @returns
	 */
	getRouteByYearAndMonthAndDay(
		year: number,
		month: number,
		day: number
	): Observable<Route[]> {
		let params = new HttpParams()
			.set('year', year.toString())
			.set('month', month.toString())
			.set('day', day.toString());
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.routeUrl}`,
			'getRouteById',
			{ params }
		);
	}

	putRoute(route: Route) {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.routeUrl}`,
			`putRoute`,
			route
		);
	}

	reaffecter(idRoute: number, idEmployee) {
		let params = new HttpParams()
			.set('idRoute', idRoute.toString())
			.set('idEmployee', idEmployee ? idEmployee.toString() : '');

		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Authorization: 'my-auth-token'
			}),
			params: params
		};
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.routeUrl}/reaffecter`,
			`reaffecter`,
			'',
			httpOptions
		);
	}

	validerRoute(idRoute: number) {
		let params = new HttpParams().set('idRoute', idRoute.toString());

		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Authorization: 'my-auth-token'
			}),
			params: params
		};
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.routeUrl}/valider`,
			`validerRoute`,
			'',
			httpOptions
		);
	}

	invaliderRoute(idRoute: number) {
		let params = new HttpParams().set('idRoute', idRoute.toString());

		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				Authorization: 'my-auth-token'
			}),
			params: params
		};
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.routeUrl}/invalider`,
			`invaliderRoute`,
			'',
			httpOptions
		);
	}

	addOrEditVehicleToRoute(idRoute: number, idVehicle: number) {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.routeUrl}/${idRoute}/vehicle/${idVehicle}`,
			'addOrEditVehicleToRoute'
		);
	}

	removeVehicleOfRoute(idRoute: number) {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.routeUrl}/${idRoute}/vehicle/remove`,
			'removeVehicleOfRoute'
		);
	}

	/**
	 *
	 * @param idRoute
	 * @returns
	 */
	getRouteItinerary(idRoute: number): Observable<number[][]> {
		let params = new HttpParams().set(
			'idRoute',
			idRoute ? idRoute.toString() : ''
		);
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.routeUrl}/itineraire`,
			'getRouteItinerary',
			{ params }
		);
	}

	getItineraryBetween(points: number[][] | LatLngExpression[]) {
		let params = new HttpParams();
		for (let pts of points) {
			if (pts) {
				params = params.append('points', pts.toString());
			}
		}

		const httpOptions = {
			// headers: new HttpHeaders({
			//     'Content-Type': 'application/json',
			//     Authorization: 'my-auth-token',
			// }),
			params: params
		};
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.routeUrl}/itineraire/points`,
			'getItineraryBetween',
			httpOptions
		);
	}
}
